import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { Diversity2Rounded, GroupAddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NoGroups = ({ action }) => {
    const { t } = useTranslation();

    return (
        <>
            <NoDataComponent
                primary={t('prompts:noData.groups.noGroups.primary')}
                secondary={t('prompts:noData.groups.noGroups.secondary')}
                Icon={Diversity2Rounded}
                action={
                    <Button
                        color="primary"
                        startIcon={<GroupAddRounded />}
                        onClick={action}
                    >
                        {t('Create Group')}
                    </Button>
                }
            />
        </>
    );
};

export default NoGroups;
